class ClickableElement {

    constructor($el) {

        this.$el = $el;
    }

    init() {

        const $mainLink = this.$el.querySelector('.js--main-link');

        if ($mainLink) {

            this.setupClick($mainLink)

        } else {
            const $allLinks = this.$el.querySelectorAll('a');

            if ($allLinks && $allLinks.length > 0) {

                this.setupClick($allLinks[0])
            }
        }
    }

    setupClick($link) {

        this.$el.addEventListener('click', (e) => {

            const isTextSelected = window.getSelection().toString();
            
            if (!isTextSelected) {
                
                // Using jQuery here to clone
                // events (like GA) as well.
                var $clone = $($link).clone(true);

                if (e.ctrlKey) {

                    $clone.attr('target', '_blank');
                }
                
                $clone[0].click();
            }
        })
    }
}

(function () {

    'use strict';

    [...document.querySelectorAll('.js--clickable')].forEach(($el) => {
    
        const inst = new ClickableElement($el);
        inst.init();
    });

})();
